import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IFiUniqueContactData } from '@fi-shared/fi-directives/fi-custom-validators/fi-unique-contact-async-validator.directive';
import { IContactModel } from '@fi-shared/models/common';
import { DataFieldPropertyType } from '@fi-app/data-field/data-field-property-type';
import { FiContactBaseDirective } from '@fi-shared/fi-contacts/fi-contact-base.directive';

@Component({
    selector: 'fi-email-address-contact',
    templateUrl: './email-address-contact.component.html',
    styleUrls: ['./email-address-contact.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-email-address-contact' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: EmailAddressContactComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: EmailAddressContactComponent,
        },
    ],
    standalone: false,
})
export class EmailAddressContactComponent extends FiContactBaseDirective implements OnInit, OnDestroy {
    @Input() dataForUniqueEmailCheck: IFiUniqueContactData;
    dataFieldPropertyType = DataFieldPropertyType.EmailAddress;

    get emailAddress(): IContactModel {
        return this.ngModel;
    }

    getDataForUniqueEmailCheck(): IFiUniqueContactData {
        if (!this.dataForUniqueEmailCheck) return {} as IFiUniqueContactData;
        return {
            ...this.dataForUniqueEmailCheck,
            isDuplicate: this.isContactDuplicate,
        };
    }
}
